/* =============================================================================
   Beirutek Custom Theme — JavaScript
   ============================================================================= */

(function () {
  'use strict';

  /* --- FAQ & Terms Accordion ---------------------------------------------- */
  function initAccordions(containerSelector) {
    const containers = document.querySelectorAll(containerSelector);
    containers.forEach((container) => {
      const items = container.querySelectorAll('.brt-faq-item, .brt-accordion-item');
      items.forEach((item) => {
        const trigger = item.querySelector('.brt-faq-trigger, .brt-accordion-trigger');
        if (!trigger) return;
        trigger.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');
          // Close all siblings
          items.forEach((sibling) => sibling.classList.remove('is-open'));
          // Toggle current
          if (!isOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          } else {
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* --- Cart Count Badge --------------------------------------------------- */
  function updateCartCount() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const badges = document.querySelectorAll('.brt-cart-count');
        badges.forEach((b) => {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'flex' : 'flex';
        });
      })
      .catch(() => {});
  }

  /* --- Quick Add to Cart -------------------------------------------------- */
  function initQuickAdd() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then((r) => r.json())
        .then(() => {
          btn.textContent = '✓ Added';
          updateCartCount();
          setTimeout(() => {
            btn.textContent = '+ Quick Add';
            btn.disabled = false;
          }, 1500);
        })
        .catch(() => {
          btn.textContent = '+ Quick Add';
          btn.disabled = false;
        });
    });
  }

    /* --- Product Card: Swatch click → swap image + update quick add --------- */
     function initCardSwatches() {
    document.addEventListener('click', (e) => {
      const swatch = e.target.closest('[data-card-swatch]');
      if (!swatch) return;

      e.preventDefault();
      e.stopPropagation();

      const card = swatch.closest('.brt-product-card');
      if (!card) return;

      const variantId = swatch.dataset.variantId;
      const variantImage = swatch.dataset.variantImage;
      const variantPrice = swatch.dataset.variantPrice;
      const variantAvailable = swatch.dataset.variantAvailable === 'true';

      const allSwatches = card.querySelectorAll('[data-card-swatch]');
      allSwatches.forEach((s) => s.classList.remove('is-selected'));
      swatch.classList.add('is-selected');

      if (variantImage) {
        const img = card.querySelector('.brt-product-card-img');
        if (img) {
          img.srcset = '';
          img.src = variantImage;
        }
      }

      if (variantPrice) {
        const priceEl = card.querySelector('.brt-price');
        if (priceEl) priceEl.textContent = variantPrice;
      }

      const quickAddBtn = card.querySelector('[data-quick-add]');
        if (quickAddBtn && variantId) {
          quickAddBtn.dataset.variantId = variantId;
          quickAddBtn.disabled = !variantAvailable;

          const labelEl = quickAddBtn.querySelector('.brt-quick-add-label');
          const isPreorder = quickAddBtn.dataset.preorder === 'true';

          if (labelEl) {
            if (isPreorder) {
              labelEl.textContent = '+ Pre-order';
            } else {
              labelEl.textContent = variantAvailable ? '+ Quick Add' : 'Sold Out';
            }
          }
        }
    });
  }

  /* --- Product Page: Variant Switcher ------------------------------------ */
  function initVariantSwitcher() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;

    const swatches = form.querySelectorAll('[data-variant-swatch]');
    const priceEl = form.querySelector('[data-product-price]');
    const atcBtn = form.querySelector('[data-atc-btn]');
    const mainImage = document.querySelector('[data-product-main-image]');

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        swatches.forEach((s) => s.classList.remove('is-selected'));
        swatch.classList.add('is-selected');

        const variantId = swatch.dataset.variantId;
        const variantPrice = swatch.dataset.variantPrice;
        const variantImage = swatch.dataset.variantImage;

        if (priceEl && variantPrice) {
          priceEl.textContent = variantPrice;
        }
        if (mainImage && variantImage) {
          mainImage.src = variantImage;
        }
        if (atcBtn) {
          atcBtn.dataset.variantId = variantId;
          updateAtcTotal();
        }
      });
    });
  }

  /* --- Product Page: Qty Stepper ----------------------------------------- */
  function initQtyStepper() {
    const steppers = document.querySelectorAll('[data-qty-stepper]');
    steppers.forEach((stepper) => {
      const decBtn = stepper.querySelector('[data-qty-dec]');
      const incBtn = stepper.querySelector('[data-qty-inc]');
      const valueEl = stepper.querySelector('[data-qty-value]');

      if (!decBtn || !incBtn || !valueEl) return;

      decBtn.addEventListener('click', () => {
        const current = parseInt(valueEl.textContent, 10) || 1;
        if (current > 1) {
          valueEl.textContent = current - 1;
          updateAtcTotal();
        }
      });

      incBtn.addEventListener('click', () => {
        const current = parseInt(valueEl.textContent, 10) || 1;
        valueEl.textContent = current + 1;
        updateAtcTotal();
      });
    });
  }

  function updateAtcTotal() {
    const qtyEl = document.querySelector('[data-qty-value]');
    const priceEl = document.querySelector('[data-product-price]');
    const atcLabel = document.querySelector('[data-atc-total]');
    const qtyInput = document.getElementById('brt-qty-input');

    if (!qtyEl) return;

    const qty = parseInt(qtyEl.textContent, 10) || 1;

    // Hidden quantity input hamesha sync hona chahiye, chahe atcLabel exist kare ya nahi
    if (qtyInput) qtyInput.value = qty;

    if (!priceEl || !atcLabel) return;

    const rawPrice = priceEl.dataset.priceRaw;
    if (!rawPrice) return;
    const total = (parseInt(rawPrice, 10) * qty) / 100;
    atcLabel.textContent = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(total);
  }

  /* --- Product Thumbnail Gallery ------------------------------------------ */
  function initGallery() {
    const thumbs = document.querySelectorAll('[data-product-thumb]');
    const mainImage = document.querySelector('[data-product-main-image]');
    if (!mainImage) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('is-selected'));
        thumb.classList.add('is-selected');
        const src = thumb.dataset.imageSrc;
        if (src) mainImage.src = src;
      });
    });
  }

  /* --- Cart Page: Quantity & Remove --------------------------------------- */
  function initCartPage() {
    const cartContainer = document.querySelector('[data-cart-items]');
    if (!cartContainer) return;

    cartContainer.addEventListener('click', (e) => {
      const decBtn = e.target.closest('[data-cart-qty-dec]');
      const incBtn = e.target.closest('[data-cart-qty-inc]');
      const removeBtn = e.target.closest('[data-cart-remove]');

      if (decBtn) {
        const key = decBtn.dataset.key;
        const qtyEl = decBtn.closest('[data-cart-item]').querySelector('[data-cart-qty]');
        const qty = Math.max(0, parseInt(qtyEl.textContent, 10) - 1);
        updateCartItem(key, qty);
      }
      if (incBtn) {
        const key = incBtn.dataset.key;
        const qtyEl = incBtn.closest('[data-cart-item]').querySelector('[data-cart-qty]');
        const qty = parseInt(qtyEl.textContent, 10) + 1;
        updateCartItem(key, qty);
      }
      if (removeBtn) {
        const key = removeBtn.dataset.key;
        updateCartItem(key, 0);
      }
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then((r) => r.json())
      .then(() => {
        window.location.reload();
      })
      .catch(() => {});
  }

  /* --- Hash Scroll (for Best Sellers / Brands anchor links) --------------- */
  function initHashScroll() {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    let tries = 0;
    const attempt = () => {
      const el = document.getElementById(id);
      if (el) {
        window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
      } else if (tries++ < 20) {
        setTimeout(attempt, 100);
      }
    };
    attempt();
  }

  /* --- Newsletter Form ----------------------------------------------------- */
  function initNewsletter() {
    const forms = document.querySelectorAll('[data-newsletter-form]');
    forms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        // Dawn handles Shopify newsletter form natively; this is a fallback
        const btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.textContent = 'Subscribing…';
        }
      });
    });
  }

  /* --- Contact Form: char counter ----------------------------------------- */
  function initContactForm() {
    const textarea = document.querySelector('[data-char-count-input]');
    const counter = document.querySelector('[data-char-count]');
    if (!textarea || !counter) return;

    const max = parseInt(textarea.dataset.maxLength || '500', 10);
    textarea.addEventListener('input', () => {
      const remaining = max - textarea.value.length;
      counter.textContent = `${textarea.value.length} / ${max}`;
      if (textarea.value.length > max) {
        textarea.value = textarea.value.slice(0, max);
      }
    });
  }

  /* --- Carousel — arrows + dots ------------------------------------------- */
  function brtInitCarousel(wrap) {
    if (wrap._brtCarousel) return;
    wrap._brtCarousel = true;

    const track = wrap.querySelector('[data-carousel-track]');
    const btnPrev = wrap.querySelector('[data-carousel-prev]');
    const btnNext = wrap.querySelector('[data-carousel-next]');
    const dotsWrap = wrap.querySelector('[data-carousel-dots]');

    if (!track) return;

    const items = Array.from(track.children);
    if (items.length < 2) {
      if (btnPrev) btnPrev.style.display = 'none';
      if (btnNext) btnNext.style.display = 'none';
      return;
    }

    if (dotsWrap) {
      items.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'brt-carousel-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
        dot.addEventListener('click', () => {
          const target = items[i];
          if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
    }

    const getStepWidth = () => {
      const gap = parseFloat(getComputedStyle(track).gap) || 14;
      return (items[0] ? items[0].offsetWidth : 0) + gap;
    };

  const updateState = () => {
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (btnPrev) btnPrev.disabled = atStart;
      if (btnNext) btnNext.disabled = atEnd;
      if (dotsWrap) {
        const sw = getStepWidth();
        let active = sw > 0 ? Math.round(track.scrollLeft / sw) : 0;
        active = Math.min(active, items.length - 1);
        // At the very end of the scroll, the last item usually doesn't
        // sit a full step away from the previous one (there's nothing
        // left to scroll past), so the rounded calculation above lands
        // one dot short. Force the last dot active once we've actually
        // reached the end.
        if (atEnd) active = items.length - 1;
        dotsWrap.querySelectorAll('.brt-carousel-dot').forEach((d, i) => {
          d.classList.toggle('is-active', i === active);
        });
      }
    };

    if (btnPrev) btnPrev.addEventListener('click', () => track.scrollBy({ left: -getStepWidth(), behavior: 'smooth' }));
    if (btnNext) btnNext.addEventListener('click', () => track.scrollBy({ left: getStepWidth(), behavior: 'smooth' }));

    track.addEventListener('scroll', updateState, { passive: true });
    updateState();
  }


    function initExploreCollectionsCarousel() {
    const section = document.querySelector('.brt-collection-grid');
    if (!section) return;

    const wrap = section.querySelector('.brt-carousel-wrap');
    const track = section.querySelector('[data-carousel-track]');
    const btnPrev = section.querySelector('[data-carousel-prev]');
    const btnNext = section.querySelector('[data-carousel-next]');
    const dotsWrap = section.querySelector('[data-carousel-dots]');

    if (!wrap || !track) return;
    if (wrap._brtExploreCarousel) return;

    wrap._brtExploreCarousel = true;

    const items = Array.from(track.children);

    if (items.length < 2) return;

    // Remove any previously generated dots
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
    }

    const getStep = () => {
      if (items.length < 2) {
        return items[0] ? items[0].offsetWidth : 0;
      }

      // Actual distance between cards
      return items[1].offsetLeft - items[0].offsetLeft;
    };

    const getMaxScroll = () => {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    };

    const getPositions = () => {
      const step = getStep();
      const max = getMaxScroll();

      if (!step || max <= 0) return [0];

      const positions = [0];

      let position = step;

      while (position < max - 2) {
        positions.push(position);
        position += step;
      }

      // Exact final reachable position
      if (max > 2) {
        positions.push(max);
      }

      return positions;
    };

    let positions = getPositions();

    const createDots = () => {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = '';
      positions = getPositions();

      positions.forEach((position, index) => {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className =
          'brt-carousel-dot' +
          (index === 0 ? ' is-active' : '');

        dot.setAttribute(
          'aria-label',
          'Go to item ' + (index + 1)
        );

        dot.addEventListener('click', () => {
          track.scrollTo({
            left: position,
            behavior: 'smooth'
          });
        });

        dotsWrap.appendChild(dot);
      });
    };

    const getCurrentIndex = () => {
      let closestIndex = 0;
      let closestDistance = Infinity;

      positions.forEach((position, index) => {
        const distance = Math.abs(
          track.scrollLeft - position
        );

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const updateState = () => {
      const max = getMaxScroll();

      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft >= max - 4;

      if (btnPrev) {
        btnPrev.disabled = atStart;
      }

      if (btnNext) {
        btnNext.disabled = atEnd;
      }

      if (dotsWrap) {
        let active = getCurrentIndex();

        if (atEnd) {
          active = positions.length - 1;
        }

        dotsWrap
          .querySelectorAll('.brt-carousel-dot')
          .forEach((dot, index) => {
            dot.classList.toggle(
              'is-active',
              index === active
            );
          });
      }
    };

    if (btnPrev) {
      btnPrev.addEventListener('click', () => {
        const current = getCurrentIndex();

        const targetIndex = Math.max(
          0,
          current - 1
        );

        track.scrollTo({
          left: positions[targetIndex],
          behavior: 'smooth'
        });
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', () => {
        const current = getCurrentIndex();

        const targetIndex = Math.min(
          positions.length - 1,
          current + 1
        );

        track.scrollTo({
          left: positions[targetIndex],
          behavior: 'smooth'
        });
      });
    }

    track.addEventListener(
      'scroll',
      updateState,
      { passive: true }
    );

    createDots();
    updateState();

    // Recalculate if screen size changes
    window.addEventListener('resize', () => {
      positions = getPositions();
      createDots();
      updateState();
    });
  }
  function initCarousels() {
    document.querySelectorAll('.brt-carousel-wrap').forEach((wrap) => {

      // Explore Our Collections ko global carousel se exclude karo
      if (wrap.closest('.brt-collection-grid')) return;

      brtInitCarousel(wrap);
    });

    initExploreCollectionsCarousel();
  }

    /* --- Tomtoc back link: scroll to #brands on homepage without adding hash to URL --- */
  function initHashScroll() {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    let tries = 0;
    const attempt = () => {
      const el = document.getElementById(id);
      if (el) {
        window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
        // Clean the hash from the URL after scrolling, without adding a new history entry
        setTimeout(() => {
          if (history.replaceState) {
            history.replaceState(null, '', window.location.pathname + window.location.search);
          }
        }, 600);
      } else if (tries++ < 20) {
        setTimeout(attempt, 100);
      }
    };
    attempt();
  }

    /* --- Hero Banner: photo rotation (cross-fade) --------------------------- */
      function initHeroBannerRotation() {
      var section = document.querySelector('.brt-bnr-section');
      if (!section) return;

      var bannerImg = section.querySelector('.brt-bnr-img');

      var hold = 5000;
      var holdAttr = section.dataset.holdMs;

      if (holdAttr) {
        hold = parseInt(holdAttr, 10) || 5000;
      }

      if (bannerImg) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            bannerImg.classList.add('is-ready');
          });
        });
      }

      function step(selector) {
        var slides = section.querySelectorAll(selector);

        if (slides.length < 2) return;

        var cur = 0;

        for (var n = 0; n < slides.length; n++) {
          if (slides[n].classList.contains('is-on')) {
            cur = n;
            break;
          }
        }

        slides[cur].classList.remove('is-on');
        slides[(cur + 1) % slides.length].classList.add('is-on');
      }

      setInterval(function () {
        step('.brt-bnr-d');
        step('.brt-bnr-m');
      }, hold);
    }

  /* --- Init All ----------------------------------------------------------- */
  function init() {
    initAccordions('.brt-faq-list, .brt-accordion-list');
    updateCartCount();
    initQuickAdd();
    initVariantSwitcher();
    initQtyStepper();
    initGallery();
    initCartPage();
    initHashScroll();
    initNewsletter();
    initContactForm();
    initCarousels();
     initCardSwatches(); 
     initHeroBannerRotation();
     initHeaderScrollState(); 
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run cart count after Shopify section events
  document.addEventListener('cart:refresh', updateCartCount);
})();